













import Vue from 'vue'
import EditOrAddMenu from './EditOrAddMenu.vue'
export default Vue.extend({
  components: {
    EditOrAddMenu
  },
  props: {
    chooseMenuKind: {
      type: String,
      default: ''
    },
    menuTypeList: {
      type: Array,
      default: ()=>[]
    },
    audienceList: {
      type: Array,
      default: ()=>[]
    }
  },
  data(){
    return{
      form: {
        audience: []
      }
    }
  },
  methods: {
    addMenuBack(flag: boolean) {
      this.$emit('addMenuBack', flag)
    },
  },
})
